<div class="govuk-width-container">
  <div class="govuk-grid-row">
    <div class="govuk-grid-column-two-thirds">
      <a id="universal_credit" class="mas-widget" target="_blank" lang="en"
href="https://www.moneyadviceservice.org.uk/en/tools/money-manager" data-width="100%">Loading...</a>
    </div>
  </div>
</div>

